import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"
import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { SchoolsMetricsPageController } from "./SchoolsMetricsPageController"
import { SchoolsMetricsPage } from "./SchoolsMetricsPage"

export function SchoolsMetricsPageDirective(): IDirective {
  return {
    restrict: "E",
    controller: "SchoolsMetricsPageController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])
      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <SchoolsMetricsPage
              controller={controller as SchoolsMetricsPageController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
